export const iqacData = {
    "naac": {
        "certificates": [
            { "name": "Certificate-Cycle-2 2022.pdf", "path": "/files/iqac/naac/NAAC Certificate/Certificate-Cycle-2 2022.pdf" },
            { "name": "Certificate Cycle-1 2016.pdf", "path": "/files/iqac/naac/NAAC Certificate/Certificate Cycle-1 2016.pdf" }
        ],
        "ssr": [
            { "name": "Cycle 2.pdf", "path": "/files/iqac/naac/NAAC SSR/Cycle 2.pdf" }
        ],
        "aqar": [
            { "name": "2023-2024.pdf", "path": "/files/iqac/naac/AQAR/2023-2024.pdf" },
            { "name": "2022-2023.pdf", "path": "/files/iqac/naac/AQAR/2022-2023.pdf" },
            { "name": "2021-2022.pdf", "path": "/files/iqac/naac/AQAR/2021-2022.pdf" },
            { "name": "2020-2021.pdf", "path": "/files/iqac/naac/AQAR/2020-2021.pdf" },
            { "name": "2019-2020.pdf", "path": "/files/iqac/naac/AQAR/2019-2020.pdf" },
            { "name": "2018-2019.pdf", "path": "/files/iqac/naac/AQAR/2018-2019.pdf" },
            { "name": "2017-2018.pdf", "path": "/files/iqac/naac/AQAR/2017-2018.pdf" },
            { "name": "2016-2017.pdf", "path": "/files/iqac/naac/AQAR/2016-2017.pdf" },
            { "name": "2015-2016.pdf", "path": "/files/iqac/naac/AQAR/2015-2016.pdf" }
        ]
    },
    "iso": [
        { "name": "Cycle 2 Certificate 10.03.2023.pdf", "path": "/files/iqac/ISO/Cycle 2 Certificate 10.03.2023.pdf" },
        { "name": "Cycle 1 Certificate 05.03.2020.pdf", "path": "/files/iqac/ISO/Cycle 1 Certificate 05.03.2020.pdf" }
    ],
    "strategic": [
        { "name": "2020-2025.pdf", "path": "/files/iqac/Strategic Plan/2020-2025.pdf" },
        { "name": "2015-2020.pdf", "path": "/files/iqac/Strategic Plan/2015-2020.pdf" }
    ],
    "bestPractices": [
        { "name": "Best Practices II.pdf", "path": "/files/iqac/Best Practices/Best Practices II.pdf" },
        { "name": "Best Practices I.pdf", "path": "/files/iqac/Best Practices/Best Practices I.pdf" }
    ],
    "annualReport": [
        { "name": "2024-2025.pdf", "path": "/files/iqac/Annual Reports/2024-2025.pdf" },
        { "name": "2023-2024.pdf", "path": "/files/iqac/Annual Reports/2023-2024.pdf" },
        { "name": "2022-2023.pdf", "path": "/files/iqac/Annual Reports/2022-2023.pdf" },
        { "name": "2021-2022.pdf", "path": "/files/iqac/Annual Reports/2021-2022.pdf" },
        { "name": "2020-2021.pdf", "path": "/files/iqac/Annual Reports/2020-2021.pdf" },
        { "name": "2019-2020.pdf", "path": "/files/iqac/Annual Reports/2019-2020.pdf" },
        { "name": "2018-2019.pdf", "path": "/files/iqac/Annual Reports/2018-2019.pdf" },
        { "name": "2017-2018.pdf", "path": "/files/iqac/Annual Reports/2017-2018.pdf" },
        { "name": "2016-2017.pdf", "path": "/files/iqac/Annual Reports/2016-2017.pdf" },
        { "name": "2015-2016.pdf", "path": "/files/iqac/Annual Reports/2015-2016.pdf" }
    ],
    "meetings": [
        { "name": "2023-2024.pdf", "path": "/files/iqac/Meeting & Minutes/2023-2024.pdf" },
        { "name": "2021-2022.pdf", "path": "/files/iqac/Meeting & Minutes/2021-2022.pdf" },
        { "name": "2020-2021.pdf", "path": "/files/iqac/Meeting & Minutes/2020-2021.pdf" },
        { "name": "2019-2020.pdf", "path": "/files/iqac/Meeting & Minutes/2019-2020.pdf" },
        { "name": "2018-2019.pdf", "path": "/files/iqac/Meeting & Minutes/2018-2019.pdf" },
        { "name": "2017-2018.pdf", "path": "/files/iqac/Meeting & Minutes/2017-2018.pdf" },
        { "name": "2016-2017.pdf", "path": "/files/iqac/Meeting & Minutes/2016-2017.pdf" },
        { "name": "2015-2016.pdf", "path": "/files/iqac/Meeting & Minutes/2015-2016.pdf" }
    ],
    "audit": {
        "files": [
            { "name": "2023-2024 Report & Action Taken.pdf", "path": "/files/iqac/Audit details/2023-2024 Report & Action Taken.pdf" },
            { "name": "2022-2023 Report & Action Taken Report.pdf", "path": "/files/iqac/Audit details/2022-2023 Report & Action Taken Report.pdf" }
        ],
        "reports": [
            { "name": "2021-2022 Report.pdf", "path": "/files/iqac/Audit details/reports/2021-2022 Report.pdf" },
            { "name": "2020-2021 Report.pdf", "path": "/files/iqac/Audit details/reports/2020-2021 Report.pdf" },
            { "name": "2019-2020 Report.pdf", "path": "/files/iqac/Audit details/reports/2019-2020 Report.pdf" },
            { "name": "2018-2019 Report.pdf", "path": "/files/iqac/Audit details/reports/2018-2019 Report.pdf" },
            { "name": "2017-2018 Report.pdf", "path": "/files/iqac/Audit details/reports/2017-2018 Report.pdf" }
        ],
        "actionTaken": [
            { "name": "2021-2022 Action Taken Report.pdf", "path": "/files/iqac/Audit details/action taken reports/2021-2022 Action Taken Report.pdf" },
            { "name": "2020-2021 Action Taken Report.pdf", "path": "/files/iqac/Audit details/action taken reports/2020-2021 Action Taken Report.pdf" },
            { "name": "2019-2020 Audit ActionReport.pdf", "path": "/files/iqac/Audit details/action taken reports/2019-2020 Audit ActionReport.pdf" },
            { "name": "2018-2019 Action Taken Report.pdf", "path": "/files/iqac/Audit details/action taken reports/2018-2019 Action Taken Report.pdf" },
            { "name": "2017-2018 Action Taken Report.pdf", "path": "/files/iqac/Audit details/action taken reports/2017-2018 Action Taken Report.pdf" }
        ]
    },
    "composition": [
        { "name": "2023.pdf", "path": "/files/iqac/Formation of IQAC/2023.pdf" },
        { "name": "2022.pdf", "path": "/files/iqac/Formation of IQAC/2022.pdf" },
        { "name": "2020.pdf", "path": "/files/iqac/Formation of IQAC/2020.pdf" },
        { "name": "2017.pdf", "path": "/files/iqac/Formation of IQAC/2017.pdf" },
        { "name": "2015.pdf", "path": "/files/iqac/Formation of IQAC/2015.pdf" }
    ],
    "gallery": [
        {
            "src": "/assets/iqac/gallery/ISO 9001-2015 surveillance audit (04.02.2025)/WhatsApp Image 2025-02-04 at 9.34.02 AM.jpeg",
            "alt": "ISO 9001-2015 surveillance audit 1"
        },
        {
            "src": "/assets/iqac/gallery/ISO 9001-2015 surveillance audit (04.02.2025)/WhatsApp Image 2025-02-04 at 9.34.04 AM (1).jpeg",
            "alt": "ISO 9001-2015 surveillance audit 2"
        }
    ],
    "affiliation": {
        "autonomous": [
            {
                "name": "3.KEC_autonomous_approval_23-33.pdf",
                "path": "/files/iqac/Affliation & Approval/AUTONOMOUS/3.KEC_autonomous_approval_23-33.pdf"
            },
            {
                "name": "2.KEC_autonomous_approval.pdf",
                "path": "/files/iqac/Affliation & Approval/AUTONOMOUS/2.KEC_autonomous_approval.pdf"
            },
            {
                "name": "1.KEC_autonomous_approval.pdf",
                "path": "/files/iqac/Affliation & Approval/AUTONOMOUS/1.KEC_autonomous_approval.pdf"
            }
        ],
        "au": [
            {
                "name": "9_KEC_AU_affiliation_11.09.2014.pdf",
                "path": "/files/iqac/Affliation & Approval/AU Affiliation/9_KEC_AU_affiliation_11.09.2014.pdf"
            },
            {
                "name": "8_KEC_AU_affiliation_23.06.2014.pdf",
                "path": "/files/iqac/Affliation & Approval/AU Affiliation/8_KEC_AU_affiliation_23.06.2014.pdf"
            },
            {
                "name": "7_KEC_AU_affiliation_21.04.2014.pdf",
                "path": "/files/iqac/Affliation & Approval/AU Affiliation/7_KEC_AU_affiliation_21.04.2014.pdf"
            },
            {
                "name": "6_KEC_AU_affiliation_Research_Centre_23.12.2013.pdf",
                "path": "/files/iqac/Affliation & Approval/AU Affiliation/6_KEC_AU_affiliation_Research_Centre_23.12.2013.pdf"
            },
            {
                "name": "5_KEC_AU_affiliation_15.05.2013.pdf",
                "path": "/files/iqac/Affliation & Approval/AU Affiliation/5_KEC_AU_affiliation_15.05.2013.pdf"
            },
            {
                "name": "4_KEC_AU_affiliation_15.05.2013.pdf",
                "path": "/files/iqac/Affliation & Approval/AU Affiliation/4_KEC_AU_affiliation_15.05.2013.pdf"
            },
            {
                "name": "3_KEC_AU_affiliation_ 19.09.2011.pdf",
                "path": "/files/iqac/Affliation & Approval/AU Affiliation/3_KEC_AU_affiliation_ 19.09.2011.pdf"
            },
            {
                "name": "2_KEC_AU_affiliation_ 22.10.2008.pdf",
                "path": "/files/iqac/Affliation & Approval/AU Affiliation/2_KEC_AU_affiliation_ 22.10.2008.pdf"
            },
            {
                "name": "21_KEC_AU_affiliation_25.07.2023.pdf",
                "path": "/files/iqac/Affliation & Approval/AU Affiliation/21_KEC_AU_affiliation_25.07.2023.pdf"
            },
            {
                "name": "20_KEC_AU_affiliation_11.08.2022.pdf",
                "path": "/files/iqac/Affliation & Approval/AU Affiliation/20_KEC_AU_affiliation_11.08.2022.pdf"
            },
            {
                "name": "2025-2026.pdf",
                "path": "/files/iqac/Affliation & Approval/AU Affiliation/2025-2026.pdf"
            },
            {
                "name": "2024-2025.pdf",
                "path": "/files/iqac/Affliation & Approval/AU Affiliation/2024-2025.pdf"
            },
            {
                "name": "1_KEC_AU_affiliation_16.04.2008.pdf",
                "path": "/files/iqac/Affliation & Approval/AU Affiliation/1_KEC_AU_affiliation_16.04.2008.pdf"
            },
            {
                "name": "19_KEC_AU_affiliation_28.07.2021.pdf",
                "path": "/files/iqac/Affliation & Approval/AU Affiliation/19_KEC_AU_affiliation_28.07.2021.pdf"
            },
            {
                "name": "18_KEC_AU_affiliation_30.06.2020.pdf",
                "path": "/files/iqac/Affliation & Approval/AU Affiliation/18_KEC_AU_affiliation_30.06.2020.pdf"
            },
            {
                "name": "17_KEC_AU_affiliation_ 03.01.2020.pdf",
                "path": "/files/iqac/Affliation & Approval/AU Affiliation/17_KEC_AU_affiliation_ 03.01.2020.pdf"
            },
            {
                "name": "16_KEC_AU_affiliation_15.05.2019.pdf",
                "path": "/files/iqac/Affliation & Approval/AU Affiliation/16_KEC_AU_affiliation_15.05.2019.pdf"
            },
            {
                "name": "15_KEC_AU_affiliation_15.05.2018.pdf",
                "path": "/files/iqac/Affliation & Approval/AU Affiliation/15_KEC_AU_affiliation_15.05.2018.pdf"
            },
            {
                "name": "14_KEC_AU_affiliation_15.05.2017.pdf",
                "path": "/files/iqac/Affliation & Approval/AU Affiliation/14_KEC_AU_affiliation_15.05.2017.pdf"
            },
            {
                "name": "13_KEC_AU_affiliation_12.05.2016.pdf",
                "path": "/files/iqac/Affliation & Approval/AU Affiliation/13_KEC_AU_affiliation_12.05.2016.pdf"
            },
            {
                "name": "12_KEC_AU_affiliation_03.04.2017.pdf",
                "path": "/files/iqac/Affliation & Approval/AU Affiliation/12_KEC_AU_affiliation_03.04.2017.pdf"
            },
            {
                "name": "11_KEC_AU_affiliation_12.05.2015.pdf",
                "path": "/files/iqac/Affliation & Approval/AU Affiliation/11_KEC_AU_affiliation_12.05.2015.pdf"
            },
            {
                "name": "10_KEC_AU_affiliation_10.11.2014.pdf",
                "path": "/files/iqac/Affliation & Approval/AU Affiliation/10_KEC_AU_affiliation_10.11.2014.pdf"
            }
        ],
        "aicte": {
            "eng": [
                {
                    "name": "9.E&T-009-1996-97 approval OF ME ED 14.11.1996.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/9.E&T-009-1996-97 approval OF ME ED 14.11.1996.pdf"
                },
                {
                    "name": "8.E&T-008-1996-99 increase in intake OF EEE 40 to 60 24.05.1996.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/8.E&T-008-1996-99 increase in intake OF EEE 40 to 60 24.05.1996.pdf"
                },
                {
                    "name": "7.E&T-007-1996-99 ext of approval 08.04.1996.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/7.E&T-007-1996-99 ext of approval 08.04.1996.pdf"
                },
                {
                    "name": "6.E&T-006-1996-97 increase in intake OF CSE 30 to 60 07.06.1995.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/6.E&T-006-1996-97 increase in intake OF CSE 30 to 60 07.06.1995.pdf"
                },
                {
                    "name": "5.E&T-005-1995-97 ext OF APPROVAL 05.06.1995.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/5.E&T-005-1995-97 ext OF APPROVAL 05.06.1995.pdf"
                },
                {
                    "name": "47.AICTE_Approval_2024_25.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/47.AICTE_Approval_2024_25.pdf"
                },
                {
                    "name": "46.AICTE_Approval_2023_24.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/46.AICTE_Approval_2023_24.pdf"
                },
                {
                    "name": "45.AICTE_Approval_2022_23.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/45.AICTE_Approval_2022_23.pdf"
                },
                {
                    "name": "44.AICTE_Approval_2021_22.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/44.AICTE_Approval_2021_22.pdf"
                },
                {
                    "name": "43.AICTE_Approval_2020-21.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/43.AICTE_Approval_2020-21.pdf"
                },
                {
                    "name": "42.E&T-042 -2019-2020 EOA 04.05.2019.PDF",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/42.E&T-042 -2019-2020 EOA 04.05.2019.PDF"
                },
                {
                    "name": "41.E&T-041 -2018-2019 EOA Corrigendum 4.7.2018 for mechatronics engineering instead MECHATRONICS.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/41.E&T-041 -2018-2019 EOA Corrigendum 4.7.2018 for mechatronics engineering instead MECHATRONICS.pdf"
                },
                {
                    "name": "40.E&T-040- 2017-2018 EOA 20.4.2017.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/40.E&T-040- 2017-2018 EOA 20.4.2017.pdf"
                },
                {
                    "name": "4.E&T-004-1994-95 APPROVAL of CHEM & EEE 12.08.1994.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/4.E&T-004-1994-95 APPROVAL of CHEM & EEE 12.08.1994.pdf"
                },
                {
                    "name": "39.E&T-039- 2016-2017 EOA 25.4.2016.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/39.E&T-039- 2016-2017 EOA 25.4.2016.pdf"
                },
                {
                    "name": "38.E&T-38-2015-16 BTECH Autonomobile EOA 07.04.20152015.PDF",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/38.E&T-38-2015-16 BTECH Autonomobile EOA 07.04.20152015.PDF"
                },
                {
                    "name": "37.E&T-037-2014-2015 EOA 2014.PDF",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/37.E&T-037-2014-2015 EOA 2014.PDF"
                },
                {
                    "name": "36.E&T-036-2013-2014 EOA AND INC. IN INTAKE CIVIL 120 to240 chem 60 to120 NEW MTECH FT & IT (CW) 19.03.2013.PDF",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/36.E&T-036-2013-2014 EOA AND INC. IN INTAKE CIVIL 120 to240 chem 60 to120 NEW MTECH FT & IT (CW) 19.03.2013.PDF"
                },
                {
                    "name": "35.E&T-035-2012-2013 EOA AND INC IN MECH ECE CSE 180 to 240 NEW ME EMB SYS & STR ENGG 10.05.2012.PDF",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/35.E&T-035-2012-2013 EOA AND INC IN MECH ECE CSE 180 to 240 NEW ME EMB SYS & STR ENGG 10.05.2012.PDF"
                },
                {
                    "name": "34.E&T-034-2011-2012 EOA AND INCREASE IN INTAKE OF MECH,ECE,CSE 120 TO 180 NEW ME COMM SYS &PED 01.09.2011.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/34.E&T-034-2011-2012 EOA AND INCREASE IN INTAKE OF MECH,ECE,CSE 120 TO 180 NEW ME COMM SYS &PED 01.09.2011.pdf"
                },
                {
                    "name": "33.E&T-033-2010-2011 EOA AND APPROVAL OF ME C&I COMP& COMM ENGG 23.08.2010.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/33.E&T-033-2010-2011 EOA AND APPROVAL OF ME C&I COMP& COMM ENGG 23.08.2010.pdf"
                },
                {
                    "name": "32.E&T-032-2008-09-2010 INCREASE IN INTKAE OF EIE & MTS 60 TO 120, IT 90 TO 120 23.05.2008.PDF",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/32.E&T-032-2008-09-2010 INCREASE IN INTKAE OF EIE & MTS 60 TO 120, IT 90 TO 120 23.05.2008.PDF"
                },
                {
                    "name": "31.E&T-031-2008-2011 EXTENSION OF APPROVAL 27.05.2008.Pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/31.E&T-031-2008-2011 EXTENSION OF APPROVAL 27.05.2008.Pdf"
                },
                {
                    "name": "30.E&T-030-2007-2008 EOA AND INCREASE IN INTKAE 60 TO 120 02.07.2007.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/30.E&T-030-2007-2008 EOA AND INCREASE IN INTKAE 60 TO 120 02.07.2007.pdf"
                },
                {
                    "name": "3.E&T-003-1994-95-96 EXT OF APPROVAL 17.04.1994.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/3.E&T-003-1994-95-96 EXT OF APPROVAL 17.04.1994.pdf"
                },
                {
                    "name": "29.E&T-029-2007-2008 EXT OF APPROVAL 22.05.2007.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/29.E&T-029-2007-2008 EXT OF APPROVAL 22.05.2007.pdf"
                },
                {
                    "name": "28.E&T-028-2006-2007 EXT OF APPROVAL & CONDITIONAL APPROVAL REMOVAL 24.05.2006.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/28.E&T-028-2006-2007 EXT OF APPROVAL & CONDITIONAL APPROVAL REMOVAL 24.05.2006.pdf"
                },
                {
                    "name": "27.E&T-027-2005-2006 EOA & IN INTAKE OF CHEM 60, EEE 120 , MECH 120, EIE 60, MTS 60 & NEW COU FT 19.09.2005.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/27.E&T-027-2005-2006 EOA & IN INTAKE OF CHEM 60, EEE 120 , MECH 120, EIE 60, MTS 60 & NEW COU FT 19.09.2005.pdf"
                },
                {
                    "name": "26.E&T-026-2005-2006 EXTENSION OF APPROVAL 24.06.2005.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/26.E&T-026-2005-2006 EXTENSION OF APPROVAL 24.06.2005.pdf"
                },
                {
                    "name": "25.E&T-025-2003-2005 CHANGE OF NOMENCLATURE ME TO MTECH Chemical 21.12.2004.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/25.E&T-025-2003-2005 CHANGE OF NOMENCLATURE ME TO MTECH Chemical 21.12.2004.pdf"
                },
                {
                    "name": "24.E&T-024-2004-2006 APPROVAL OF ME ME MECHATRONICS 22.07.2004.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/24.E&T-024-2004-2006 APPROVAL OF ME ME MECHATRONICS 22.07.2004.pdf"
                },
                {
                    "name": "23.E&T-023-2003-2005 EXT OF APPROVAL ME ED CSE CEM 21.08.2003.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/23.E&T-023-2003-2005 EXT OF APPROVAL ME ED CSE CEM 21.08.2003.pdf"
                },
                {
                    "name": "22.E&T-022-2003-2005 APPROVAL OF ME VLSI 25.08.2003.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/22.E&T-022-2003-2005 APPROVAL OF ME VLSI 25.08.2003.pdf"
                },
                {
                    "name": "21.E&T-021-2003-2005 APPROVAL OF ME CHEMICAL Engg 07.07.2003.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/21.E&T-021-2003-2005 APPROVAL OF ME CHEMICAL Engg 07.07.2003.pdf"
                },
                {
                    "name": "20.E&T-020-2003-2005 APPROVAL OF ME CAD CAM 07.07.2003.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/20.E&T-020-2003-2005 APPROVAL OF ME CAD CAM 07.07.2003.pdf"
                },
                {
                    "name": "2.E&T-002-1993-94 ext of APPROVAL 28.10.1993.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/2.E&T-002-1993-94 ext of APPROVAL 28.10.1993.pdf"
                },
                {
                    "name": "19.E&T-019-2003-05 APPROVAL OF ME CONST ENGG AND MGMT 27.03.2003.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/19.E&T-019-2003-05 APPROVAL OF ME CONST ENGG AND MGMT 27.03.2003.pdf"
                },
                {
                    "name": "18.E&T-018-2002-2003 INCREASE IN INTAKE OF ME CSE & ED 18 TO 2529.08.2002.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/18.E&T-018-2002-2003 INCREASE IN INTAKE OF ME CSE & ED 18 TO 2529.08.2002.pdf"
                },
                {
                    "name": "17.E&T-017-2002-2005 EOA & INCREASE IN INTAKE OF ECE 90 TO 120, CIVIL 30 TO 60.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/17.E&T-017-2002-2005 EOA & INCREASE IN INTAKE OF ECE 90 TO 120, CIVIL 30 TO 60.pdf"
                },
                {
                    "name": "16.E&T-016-2002-2003 APPROVAL OF ME AE 08.02.2002.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/16.E&T-016-2002-2003 APPROVAL OF ME AE 08.02.2002.pdf"
                },
                {
                    "name": "15.E&T-015-2001-2003 EOA AND INCREASE IN INTKAE OF CSE 90 TO 120 22.06.2001.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/15.E&T-015-2001-2003 EOA AND INCREASE IN INTKAE OF CSE 90 TO 120 22.06.2001.pdf"
                },
                {
                    "name": "14.E&T-014-2000-2001 EOA & INCREASE IN INTAKE OF ECE CSE IT FROM 60 TO 90 14.11.2000.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/14.E&T-014-2000-2001 EOA & INCREASE IN INTAKE OF ECE CSE IT FROM 60 TO 90 14.11.2000.pdf"
                },
                {
                    "name": "13.E&T-013-1999-2000 APPROVAL OF ME CSE 25.08.1999.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/13.E&T-013-1999-2000 APPROVAL OF ME CSE 25.08.1999.pdf"
                },
                {
                    "name": "12.E&T-012-1999-2002 EOA & INCREASE IN INTKAE OF EIE, IT AND NEW COURSE MTS 29.06.1999.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/12.E&T-012-1999-2002 EOA & INCREASE IN INTKAE OF EIE, IT AND NEW COURSE MTS 29.06.1999.pdf"
                },
                {
                    "name": "11.E&T-011-1998-99 approval of IT 09.06.1998.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/11.E&T-011-1998-99 approval of IT 09.06.1998.pdf"
                },
                {
                    "name": "10.E&T-010-1997-99 approval of EIE 29.08.1997.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/10.E&T-010-1997-99 approval of EIE 29.08.1997.pdf"
                },
                {
                    "name": "1.E&T-001-1993-94 FIRST APPROVAL OF THE COLLEGE (E&T) 19.04.1993 001.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/ENG/1.E&T-001-1993-94 FIRST APPROVAL OF THE COLLEGE (E&T) 19.04.1993 001.pdf"
                }
            ],
            "mca": [
                {
                    "name": "9.MCA-009-2005-2006 EOA APPROVAL ALONGWITH E&T APPROVAL 19.09.2005.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/MCA/9.MCA-009-2005-2006 EOA APPROVAL ALONGWITH E&T APPROVAL 19.09.2005.pdf"
                },
                {
                    "name": "8.MCA-008-2002-2005 EXT OF APPROVAL 19.06.2002.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/MCA/8.MCA-008-2002-2005 EXT OF APPROVAL 19.06.2002.pdf"
                },
                {
                    "name": "7.MCA-007-2001-2002 EXT OF APPROVAL 21.06.2001.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/MCA/7.MCA-007-2001-2002 EXT OF APPROVAL 21.06.2001.pdf"
                },
                {
                    "name": "6.MCA-006-1999-2001 EXT OF APPROVAL 16.07.1999.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/MCA/6.MCA-006-1999-2001 EXT OF APPROVAL 16.07.1999.pdf"
                },
                {
                    "name": "5.MCA-005-1998-99 ext of approval & increase in intake 30 to 60 09.09.1998.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/MCA/5.MCA-005-1998-99 ext of approval & increase in intake 30 to 60 09.09.1998.pdf"
                },
                {
                    "name": "4.MCA-004-1998-99 ext of approval 21.07.1998.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/MCA/4.MCA-004-1998-99 ext of approval 21.07.1998.pdf"
                },
                {
                    "name": "3.MCA-003-1997-98 ext of approval 1997-98 18.06.1997.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/MCA/3.MCA-003-1997-98 ext of approval 1997-98 18.06.1997.pdf"
                },
                {
                    "name": "23.MCA-023-2019-2020 Extension of Approval 04.05.2019.PDF",
                    "path": "/files/iqac/Affliation & Approval/AICTE/MCA/23.MCA-023-2019-2020 Extension of Approval 04.05.2019.PDF"
                },
                {
                    "name": "22.MCA-022-2018-2019 Extension of Approval 21.04.2018.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/MCA/22.MCA-022-2018-2019 Extension of Approval 21.04.2018.pdf"
                },
                {
                    "name": "21.MCA-021-2017-2018 Extension of Approval 20.04.2017.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/MCA/21.MCA-021-2017-2018 Extension of Approval 20.04.2017.pdf"
                },
                {
                    "name": "20.MCA-020-2016-2017 Extension of Approval 25.04.2016.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/MCA/20.MCA-020-2016-2017 Extension of Approval 25.04.2016.pdf"
                },
                {
                    "name": "2.MCA-002-1996-97 ext of approval 01.07.1996.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/MCA/2.MCA-002-1996-97 ext of approval 01.07.1996.pdf"
                },
                {
                    "name": "19.MCA-019-2015-2016 Extension of approval 07.06.2015.PDF",
                    "path": "/files/iqac/Affliation & Approval/AICTE/MCA/19.MCA-019-2015-2016 Extension of approval 07.06.2015.PDF"
                },
                {
                    "name": "18.MCA-018-2014-2015 Extension of approval 04.06.2014.PDF",
                    "path": "/files/iqac/Affliation & Approval/AICTE/MCA/18.MCA-018-2014-2015 Extension of approval 04.06.2014.PDF"
                },
                {
                    "name": "17.MCA-017-2013-2014 Extension of approval 19.03.2013.PDF",
                    "path": "/files/iqac/Affliation & Approval/AICTE/MCA/17.MCA-017-2013-2014 Extension of approval 19.03.2013.PDF"
                },
                {
                    "name": "16.MCA-016-2012-2013 Extension of approval 10.05.2012.PDF",
                    "path": "/files/iqac/Affliation & Approval/AICTE/MCA/16.MCA-016-2012-2013 Extension of approval 10.05.2012.PDF"
                },
                {
                    "name": "15.MCA-015-2011-2012 EXTENSION OF APPROVAL 01.09.2011.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/MCA/15.MCA-015-2011-2012 EXTENSION OF APPROVAL 01.09.2011.pdf"
                },
                {
                    "name": "14.MCA-014-2010-2011EXTENSION OF APPROVAL 23.08.2010.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/MCA/14.MCA-014-2010-2011EXTENSION OF APPROVAL 23.08.2010.pdf"
                },
                {
                    "name": "13.MCA-013-2008-2011 EXT OF APPROVAL 08.05.2008.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/MCA/13.MCA-013-2008-2011 EXT OF APPROVAL 08.05.2008.pdf"
                },
                {
                    "name": "12.MCA-012-2007-2008 INCREASE IN INTAKE 60 TO 120 24.08.2007.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/MCA/12.MCA-012-2007-2008 INCREASE IN INTAKE 60 TO 120 24.08.2007.pdf"
                },
                {
                    "name": "11.MCA-011-2007-2008 EXT OF APPROVAL 10.05.2007.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/MCA/11.MCA-011-2007-2008 EXT OF APPROVAL 10.05.2007.pdf"
                },
                {
                    "name": "10.MCA-010-2006-2007 EXT OF APPROVAL 25.05.2006.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/MCA/10.MCA-010-2006-2007 EXT OF APPROVAL 25.05.2006.pdf"
                },
                {
                    "name": "1.MCA-001-1995-96 first approval 16.08.1995.pdf",
                    "path": "/files/iqac/Affliation & Approval/AICTE/MCA/1.MCA-001-1995-96 first approval 16.08.1995.pdf"
                }
            ]
        }
    }
,
    "gallery": {
    "current": [
        {
            "src": "/assets/iqac/gallery/ISO 9001-2015 surveillance audit (04.02.2025)/WhatsApp Image 2025-02-04 at 9.34.02 AM.jpeg",
            "alt": "WhatsApp Image 2025-02-04 at 9.34.02 AM.jpeg"
        },
        {
            "src": "/assets/iqac/gallery/ISO 9001-2015 surveillance audit (04.02.2025)/WhatsApp Image 2025-02-04 at 9.34.04 AM (1).jpeg",
            "alt": "WhatsApp Image 2025-02-04 at 9.34.04 AM (1).jpeg"
        }
    ],
    "archived": []
}
};